import axios from "./index";

class ApoderadosApi {
  static fetchApoderadosSoft = () => {
    return axios.get(`/procesos/apoderados/soft`);
  };
  static fetchApoderadoByIdentificacion = (identificacion) => {
    return axios.get(`/procesos/apoderados/${identificacion}/`);
  };
  static fetchApoderadosProceso = (id) => {
    return axios.get(`/procesos/apoderados/proceso/${id}/`);
  };
  static fetchApoderadosAcreedor = (id) => {
    return axios.get(`/procesos/apoderados/acreedor/${id}/`);
  };
  static fetchApoderadosCliente = (id) => {
    return axios.get(`/procesos/apoderados/cliente/${id}/`);
  };
  static createApoderado = (data) => {
    return axios.post(`/procesos/apoderados/crear/`, data);
  };
  static updateApoderado = (id, data) => {
    return axios.put(`/procesos/apoderados/${id}/actualizar/`, data);
  };
  static deleteApoderado = (id) => {
    return axios.delete(`/procesos/apoderados/${id}/eliminar/`);
  };
}
export default ApoderadosApi;
